import { NavLink } from "react-router";
import logo from "url:./images/logo.png";

export function Header() {
  return (
    <>
      <div id="header">
        <div id="logo">
          <a href="index.php">
            <img src={logo} width="224" height="49" alt="CodeRight logo" />
          </a>
        </div>
      </div>

      <div id="nav">
        <ul>
          <li>
            <NavLink to="profile">Profile</NavLink>
          </li>
        </ul>
      </div>
    </>
  );
}
